
export const getCLPermissions = ({ selectedPermissionLabel }) => {

    const selectedPermission = selectedPermissionLabel || ""


    let CL1_CL2_CL9_Permission = false;
    let CL3_CL4_CL5_Permission = false;
    let CL6_CL7_CL8_Permission = false;
    let CL4_CL7_Permission = false;
    if (!!selectedPermission) {
        const cl1_cl2_cl9_regEx = /CL1|CL2|CL9/;
        const foundMatchForcl1cl2cl9 = selectedPermission.search(cl1_cl2_cl9_regEx)
        CL1_CL2_CL9_Permission = foundMatchForcl1cl2cl9 === 0 ? true : false


        const cl3_cl4_cl5_regEx = /CL3|CL4|CL5/
        const foundMatchForcl3cl4cl5 = selectedPermission.search(cl3_cl4_cl5_regEx)
        CL3_CL4_CL5_Permission = foundMatchForcl3cl4cl5 === 0 ? true : false


        const cl6_cl7_cl8_regEx = /CL6|CL7|CL8/;
        const foundMatchcl6cl7cl8 = selectedPermission.search(cl6_cl7_cl8_regEx)
        CL6_CL7_CL8_Permission = foundMatchcl6cl7cl8 === 0 ? true : false


        const cl4_cl7_regEx = /CL4|CL7/;
        const foundMatchcl4cl7 = selectedPermission.search(cl4_cl7_regEx)
        CL4_CL7_Permission = foundMatchcl4cl7 === 0 ? true : false

    } else {
        CL1_CL2_CL9_Permission = false;
        CL3_CL4_CL5_Permission = false;
        CL6_CL7_CL8_Permission = false;
        CL4_CL7_Permission = false;
    }

    return {
        CL1_CL2_CL9_Permission,
        CL3_CL4_CL5_Permission,
        CL6_CL7_CL8_Permission,
        CL4_CL7_Permission,
    }
}